export const EventsController = {
    index(): void {},
    ongoing(): void {},
    ended(): void {},
};
